import { useEffect, useState } from 'react';
import {
  DEFAULT_LOUNGE_MAINTENANCE,
  LOUNGE_MAINTENANCE_POLL_MS,
  LOUNGE_MAINTENANCE_STORAGE_KEY,
  LoungeMaintenanceState,
  fetchLoungeMaintenanceConfig,
  getEffectiveLoungeMaintenanceConfig,
} from '../utils/loungeMaintenance';

export function useLoungeMaintenanceMode(
  shouldPoll: boolean
): LoungeMaintenanceState {
  const [state, setState] = useState<LoungeMaintenanceState>({
    config: { ...DEFAULT_LOUNGE_MAINTENANCE },
    isLoading: false,
  });

  useEffect(() => {
    if (!shouldPoll) {
      setState({
        config: { ...DEFAULT_LOUNGE_MAINTENANCE },
        isLoading: false,
      });
      return;
    }

    let cancelled = false;

    const refresh = async () => {
      const remoteConfig = await fetchLoungeMaintenanceConfig();
      if (cancelled) return;
      setState({
        config: getEffectiveLoungeMaintenanceConfig(remoteConfig),
        isLoading: false,
      });
    };

    refresh();

    const timer = window.setInterval(() => {
      if (document.hidden) return;
      refresh();
    }, LOUNGE_MAINTENANCE_POLL_MS);

    const handleStorage = (event: StorageEvent) => {
      if (event.key === LOUNGE_MAINTENANCE_STORAGE_KEY) {
        refresh();
      }
    };

    window.addEventListener('storage', handleStorage);

    return () => {
      cancelled = true;
      window.clearInterval(timer);
      window.removeEventListener('storage', handleStorage);
    };
  }, [shouldPoll]);

  return state;
}
